import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import { FiltersLayout, FiltersButtons, SearchField } from '../../../../components';
import { EventDropdown } from './event-type-dropdown';

interface IClosingCalendarFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedEventTypes: any[];
  setSelectedEventTypes: (val: any) => void;
  isDisabled: boolean;
  searchPlaceholder: string;
  handleSearch: (val: string) => void;
  searchValue: string;
  setSearchValue: (val: string) => void;
}

export const ClosingCalendarFilters: FC<IClosingCalendarFilters> = ({
  isLoading,
  applyFilters,
  selectedEventTypes,
  setSelectedEventTypes,
  isDisabled,
  searchPlaceholder,
  handleSearch,
  searchValue,
  setSearchValue
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={3}>
        <SearchField
          isDisabled={isLoading}
          placeholder={searchPlaceholder}
          handleSearch={handleSearch}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <EventDropdown
          value={selectedEventTypes}
          handleChange={value => setSelectedEventTypes(value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchValue && setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
